<template>
  <tr ref="row">
    <td>
      <div class="td-truncate max-300 m-auto"
           :title="title"
           data-bs-toggle="tooltip"
           data-bs-placement="auto"
      >
        {{ title }}
      </div>
    </td>
    <td>
      <span class="d-block m-auto censorship-icon" :class="[uncensored ? 'uncensored' : 'censored']"></span>
    </td>
    <td ref="descriptionCell">
      <div class="td-truncate m-auto max-fluid"
           :title="description"
           data-bs-toggle="tooltip"
           data-bs-placement="auto">
        {{ description }}
      </div>
    </td>
    <td>
      {{ (episodes) ? episodes.join(', ') : null }}
    </td>
    <td>
      <a class="text-decoration-none" :href="malUrl">{{ mal }}</a>
    </td>
    <td>
      <a class="text-decoration-none" :href="anidbUrl">{{ anidb }}</a>
    </td>
    <td></td>
  </tr>
</template>

<script>
import {Tooltip} from "bootstrap";
import {url} from '@/constants';

export default {
  name: "TableData",
  props: {
    id: Number,
    title: String,
    uncensored: Boolean,
    description: String,
    episodes: Array,
    mal: Number,
    anidb: Number,
    darkMode: Boolean
  },
  data() {
    return {
      episodesRdbl: '',
      tooltips: [],
      anidbUrl: `${url.ANI_DB}/${this.anidb}`,
      malUrl: `${url.MAL}/${this.mal}`
    }
  },
  mounted() {
    const tooltipElements = this.$refs.row.querySelectorAll('[data-bs-toggle="tooltip"]');

    for (const element of tooltipElements) {
      this.tooltips.push({tooltip: new Tooltip(element), element: element});
    }

    this.setToolTips();
    window.addEventListener('resize', () => {
      this.setToolTips();
    });
  },
  methods: {
    setToolTips() {
      this.tooltips.forEach(data => {
        if (data.element.clientWidth < data.element.scrollWidth || data.element.clientHeight < data.element.scrollHeight) {
          data.tooltip.enable();
        } else {
          data.tooltip.disable();
        }
      });
    }
  }
}
</script>

<style scoped>
td > .td-truncate {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.max-300 {
  max-width: 300px;
}

@media only screen and (max-width: 480px) {
  .max-300 {
    max-width: calc(100vw - 150px);
  }
}

.max-fluid {
  max-width: 300px;
}

@media only screen and (min-width: 1330px) {
  .max-fluid {
    max-width: 600px;
  }
}

@media only screen and (min-width: 1900px) {
  .max-fluid {
    max-width: 900px;
  }
}
</style>
